class SmoothScroll {
  static EXCLUDED_SELECTORS = [
    'cart-drawer',
    'menu-drawer',
    'header-drawer',
    'details-modal',
    'product-modal',
    'pickup-availability-drawer',
    'facet-filters-form',
    'localization-form',
    'predictive-search',
  ].join(',');

  constructor() {
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.bindEvents();
    requestAnimationFrame(() => {
      this.correctInitialHash();
    });
  }

  bindEvents() {
    document.addEventListener('click', this.onAnchorClick);
    window.addEventListener('hashchange', this.onHashChange);
  }

  onHashChange = () => {
    const target = this.getTarget(window.location.hash);
    if (!target) return;
    this.scrollToElement(target, !this.prefersReducedMotion.matches);
  };

  onAnchorClick = (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || this.shouldIgnoreLink(link)) return;

    const hash = link.getAttribute('href');
    const target = this.getTarget(hash);
    if (!target) return;

    event.preventDefault();

    const smooth = !this.prefersReducedMotion.matches;
    this.scrollToElement(target, smooth);
    this.updateHistory(hash);
    this.focusTarget(target);
  };

  shouldIgnoreLink(link) {
    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return true;
    if (link.closest(SmoothScroll.EXCLUDED_SELECTORS)) return true;
    if (link.hasAttribute('data-no-smooth-scroll')) return true;
    return false;
  }

  getTarget(hash) {
    if (!hash || hash === '#') return null;

    const id = decodeURIComponent(hash.slice(1));
    if (!id) return null;

    return document.getElementById(id);
  }

  correctInitialHash() {
    const target = this.getTarget(window.location.hash);
    if (!target) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.scrollToElement(target, false);
      });
    });
  }

  updateHistory(hash) {
    if (window.location.hash === hash) return;

    if (history.pushState) {
      history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }
  }

  focusTarget(target) {
    if (target.matches(':focus')) return;

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    target.focus({ preventScroll: true });
  }

  scrollToElement(element, smooth = true) {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    const offset = (Number.isFinite(headerHeight) ? headerHeight : 0) + 16;
    const top = Math.max(0, element.getBoundingClientRect().top + window.scrollY - offset);

    window.scrollTo({
      top,
      behavior: smooth && !this.prefersReducedMotion.matches ? 'smooth' : 'auto',
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.smoothScroll = new SmoothScroll();
  });
} else {
  window.smoothScroll = new SmoothScroll();
}
